import { render, staticRenderFns } from "./YunoAPMRedirect.vue?vue&type=template&id=70264dc6"
import script from "./YunoAPMRedirect.vue?vue&type=script&lang=js"
export * from "./YunoAPMRedirect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports